








import Vue from 'vue';
import JerseyButton from '@/components/elements/JerseyButton.vue';

export default Vue.extend({
  name: 'JerseyButtonYellow',
  props: {
    view: String,
    action: Function,
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {},
  components: { JerseyButton },
});
